import React, { createContext, useContext, useState } from 'react'
import { Onboard } from '../types/Onboard'

type PropsOnboardingContext = {
  state: Onboard
  dispatch: React.Dispatch<React.SetStateAction<Onboard>>
}

const DEFAULT_VALUE = {
  state: {
    cnpj: '',
    antt: '',
    email: '',
    doc_imagem_frente: '',
    doc_imagem_verso: '',
    doc_token_sdk: '',
    senha: '',
    telefone: '',
    endereco: {
      bairro: '',
      cep: '',
      cidade: '',
      cidade_ibge: '',
      complemento: '',
      estado: '',
      logradouro: '',
      numero: '',
    },
  },
  dispatch: () => {
    return 0
  },
}
// Context
const OnboardingContext = createContext<PropsOnboardingContext>(DEFAULT_VALUE)
// hook para usar o Context
export const useOnboardContext = (): PropsOnboardingContext =>
  useContext(OnboardingContext)
// Provider
const ContextProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useState<Onboard>(DEFAULT_VALUE.state)
  return (
    <OnboardingContext.Provider value={{ state, dispatch }}>
      {children}
    </OnboardingContext.Provider>
  )
}

export default ContextProvider
